<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card>
            <iframe
              width="100%"
              height="860"
              type="application/pdf"
              src="data:application/pdf;base64, "
              frameborder="0"
              :src="this.srcpdf"
              allowfullscreen
            ></iframe>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "CreateGeneral",
  data() {
    return {
      selected: "",
      sex: "",
      thai_student: "",
      current_erorrtxt: "",
      dangerModal: false,
      current_questionid: "",
      current_questionname: "",
      current_ansnumber: "",
      current_ans: "",
      i: 0,
      items: [],
      srcpdf: ""
    };
  },
  methods: {
    getCurrentStudent(studentid, thaistudent) {
      api
        .getStudentReportPostPay(studentid, thaistudent)
        .then(res => {
          // console.log("res", res);
          // console.log("token", this.$store.state.token );
          this.srcpdf = "data:application/pdf;base64, " + res.data.data;
          // console.log(this.srcpdf);
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          return 0;
        });
    }
  },
  mounted() {},
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.thai_student = this.$store.state.user.thaistudent;
    this.levelid = this.$store.state.user.levelid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id, this.thai_student);
  }
};
</script>
<style>
</style>
